import { useEffect } from "react";

import { runtimeSettings } from "../../utils/api";
import { marketingDestination } from "../../utils/marketing";

function MarketingRedirect() {
  useEffect(() => {
    let active = true;
    runtimeSettings()
      .then(settings => {
        if (active) window.location.replace(marketingDestination(settings?.marketingUrl));
      })
      .catch(() => {
        if (active) window.location.replace(marketingDestination(null));
      });
    return () => { active = false; };
  }, []);

  return (
    <main className="fera-centered fera-secure-shell" aria-live="polite">
      <p>Opening the FeraSurvey product page&hellip;</p>
    </main>
  );
}

export default MarketingRedirect;

